import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'

interface BackupCodesDialogProps {
  show: boolean
  onClose: () => void
  backupCodes: string[]
}

export const BackupCodesDialog = ({
  show,
  onClose,
  backupCodes,
}: BackupCodesDialogProps) => {
  return (
    <Dialog
      show={show}
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title>Backup Codes</Dialog.Title>
      </Dialog.Header>
      <Dialog.Description>
        <p className="mt-4 text-center">
          Save and record the 8 codes below as a backup, they only appear once
          and will not appear again. Make sure to keep them in a safe place,
          such as your password manager.
        </p>
      </Dialog.Description>
      <div className="mt-2 grid grid-cols-2 flex-col items-center justify-center gap-4 rounded bg-secondary-50 p-4 dark:bg-secondary-600">
        {backupCodes.map((code) => (
          <span
            className="text-center text-lg font-normal"
            key={code}
          >
            {code}
          </span>
        ))}
      </div>
      <Dialog.Footer>
        <Button
          type="submit"
          onClick={onClose}
          className="w-full"
        >
          Got it!
        </Button>
      </Dialog.Footer>
    </Dialog>
  )
}
